'use client';

import { useIntl } from 'react-intl';
import { Notification } from '@packages/shared/src/ui/Notification/Notification';
import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';

export type ErrorFallbackProps = {
  onClose: () => void;
};

export const ErrorFallback = ({ onClose }: ErrorFallbackProps) => {
  const { formatMessage } = useIntl();

  return (
    <Dialog isOpen onClose={onClose} allowBackdropClose>
      <DialogContent>
        <div className="m-auto max-w-[54.438rem] p-1">
          <Notification severity="warning">
            {formatMessage({
              id: 'imageZoom.errorFallback.notification',
              defaultMessage:
                'Fehler beim Laden. Bitte überprüfe deine Internetverbindung und versuche es erneut.',
            })}
          </Notification>
        </div>
      </DialogContent>
    </Dialog>
  );
};
